import { useState, useEffect, useRef, useCallback } from "react";
import HandleFeedback from "@/modules/autres/HandleFeedback";
import ModuleFeedbackTargets from "@/modules/reeducation/ModulesFeedbackTargets";
import { saveResultsModules } from "@/utils/saveResultsModules";

interface Props {
  targetPositions: {
    sameShape: boolean;
    targets: {
      position: string;
      size: number;
      gif: string;
      blinkAndResizing: boolean;
    }[];
  }[];
  caseSize: number;
  isPausedAndNotFullScreenRef: React.MutableRefObject<boolean>;
  feedbackField: string;
  sessionId: string;
  totalDuration: number;
  nextModule: () => void;
  role: string;
}
interface showNewTarget {
  triggerShowNewTarget(): void;
}

const ChampsProfondFormesFeedback = ({
  isPausedAndNotFullScreenRef,
  targetPositions,
  caseSize,
  feedbackField,
  sessionId,
  totalDuration,
  nextModule,
  role
}: Props) => {
  const [champsProfondActif, setChampsProfondActif] = useState(true);
  const successCount = useRef(0);
  const failureCount = useRef(0);
  const answer = useRef<boolean | null>(null);

  const onSave = useCallback(() => {
    const value = {
      successCount: successCount.current,
      failureCount: failureCount.current,
    };
    saveResultsModules(
      [{ field: feedbackField, value: JSON.stringify(value) }],
      sessionId,
      role
    );
  }, [feedbackField, sessionId, role]);


  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowRight") {
        onSave();
        nextModule();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onSave, nextModule]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onSave(); // Trigger save when time is up
      nextModule();
    }, totalDuration * 1000*60); // Convert duration to minutes

    return () => clearTimeout(timer); // Clean up timer if component unmounts
  }, [totalDuration, onSave, nextModule]);

  const ModuleFeedbackTargetsRef = useRef<showNewTarget | null>(null);

  const showNewTarget = () => {
    if (ModuleFeedbackTargetsRef.current) {
      ModuleFeedbackTargetsRef.current.triggerShowNewTarget();
    }
  };

  useEffect(() => {
    if (champsProfondActif) {
      showNewTarget();
      setTimeout(() => {
        setChampsProfondActif(false);
      }, 10000);
    }
  }, [champsProfondActif]);

  return (
    <div>
      {champsProfondActif ? (
        <ModuleFeedbackTargets
          ref={ModuleFeedbackTargetsRef}
          caseSize={caseSize}
          isPausedAndNotFullScreenRef={isPausedAndNotFullScreenRef}
          backgroundColor="black"
          movementMode="blink"
          targetPositions={targetPositions}
          targetColor={["white"]}
          answer={answer}
        />
      ) : (
        <HandleFeedback
          instructions="La forme présentée est-elle la même que celle présentée à gauche/droite ?"
          answer={answer}
          setChampsProfondActif={setChampsProfondActif}
          successCountRef={successCount}
          failureCountRef={failureCount}
        />
      )}
      {/* <div>
        <p>Successes: {successCount.current}</p>
        <p>Failures: {failureCount.current}</p>
      </div> */}
    </div>
  );
};

export default ChampsProfondFormesFeedback;
